export default __webpack_public_path__ + "static/media/attachment-icon.a6ee133f.svg";